import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { search } from "actions/scooter/billing-mode-tariff/actions";

const ModalEditScooterBillingModeTariff = ({
                                             tariffId,
                                             onSave,

                                             search,
                                             billingModeTariffList
                                           }) => {
  const [tariff, setTariff] = useState(tariffId);
  const [duration, setDuration] = useState(0);
  const tariffChanged = useRef(null);
  const durationChanged = useRef(null);

  useEffect(() => {
    search(0, 1000, undefined);
  }, [search]);

  const handleSave = () => {
    onSave(tariffChanged.current ? tariff : null, durationChanged.current ? duration : null);
  };

  return (
    <div>
      <div className="form-group">
        <label>Duration</label>
        <div className="input-group">
          <input className="form-control" type="number" value={duration}
                 onChange={ev => {
                   durationChanged.current = true;
                   setDuration(+ev.target.value);
                 }}/>
          <div className="input-group-append">
            <span className="input-group-text">Minutes</span>
          </div>
        </div>
      </div>
      <div className="form-group">
        <label>Billing Mode Tariff</label>
        <select className="form-control" value={tariff} onChange={ev => {
          tariffChanged.current = true;
          setTariff(ev.target.value);
        }}>
          {billingModeTariffList.filter(i => i.mode !== "DO_NOT_SIT")
            .map(i => {
              const translations = i.translations.find(t => t.language === "hy");
              return (
                <option key={i.id} value={i.id}>
                  {translations ? translations.title : i.mode}
                </option>
              );
            })}
        </select>
      </div>

      <div className="text-right">
        <button className="btn btn-success" onClick={handleSave}>Save</button>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  billingModeTariffList: state.billingModeTariff.list.content,
});

const mapStateToDispatch = dispatch => ({
  search: bindActionCreators(search, dispatch)
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ModalEditScooterBillingModeTariff);



// WEBPACK FOOTER //
// ./src/views/pages/users/modal-edit-scooter-billing-mode-tariff.js